import React, { Component } from "react";
import RootOpening from "container/opening/RootOpening";
import AppUpdateCheckpoint from "container/common/AppUpdateCheckpoint";

class OpeningPage extends Component {
  render() {
    return (
      <AppUpdateCheckpoint>
        <RootOpening />
      </AppUpdateCheckpoint>
    );
  }
}

export default OpeningPage;
